import { TabsTrigger, TabsList, Tabs } from "@pushpress/pushpress-ui";
import { tabs } from "../../constants";
import { PeopleType } from "../../types";

type TabsPropsType = {
  activeTab: PeopleType;
  handleTabChange: (tab: PeopleType) => void;
};

export default function TableTabs({
  activeTab,
  handleTabChange,
}: TabsPropsType) {
  return (
    <Tabs value={activeTab} onValueChange={handleTabChange}>
      <TabsList className="tw-w-full">
        {tabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value} className="tw-flex-1">
            {tab.name}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
